import DOMPurify from 'dompurify';


/**
 * Sanitizes user input in multiple layers
 * 1. Basic cleaning of dangerous characters
 * 2. DOMPurify for XSS protection
 * 3. Space normalization
 */
export function sanitizeInput(input: string): string {
    // Layer 1: Remove control and non-printable characters (except \n and \r)
    let sanitized = input.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');

    // Layer 2: DOMPurify - protection against XSS
    if (typeof window !== 'undefined' && DOMPurify) {
        sanitized = DOMPurify.sanitize(sanitized, {
            ALLOWED_TAGS: [], // No permitir ningún HTML
            ALLOWED_ATTR: [], // No permitir atributos
            KEEP_CONTENT: true, // Mantener el texto
            RETURN_DOM: false,
            RETURN_DOM_FRAGMENT: false,
        });
    }

    // Layer 3: Limit to safe characters and normalize
    sanitized = sanitized.replace(/[^\p{L}\p{N}\s.,;:!?¿¡()\-'"/\n\r@#$%&+=*]/gu, '');

    // Layer 4: Normalize excessive white space
    sanitized = sanitized.replace(/\s+/g, ' ').trim();

    return sanitized;
}
